import { render } from "./QSelectPermission.vue?vue&type=template&id=65efedf2&scoped=true"
import script from "./QSelectPermission.vue?vue&type=script&lang=js"
export * from "./QSelectPermission.vue?vue&type=script&lang=js"

import "./QSelectPermission.vue?vue&type=style&index=0&id=65efedf2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65efedf2"]])

export default __exports__